"use strict";

module.exports = function (column) {
  return this.userColumnsDisplay.length === 1 && this.userColumnsDisplay[0] === column;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/only-column.js
// module id = 1611
// module chunks = 64